import { assetUrl } from '@/helpers/assetUrl';

export default {
  path: '/keyword-tool',
  name: 'keyword-research', // 'keywords' is the name of the route, 'keywords' is the name of the module, 'keywords' is the name of the folder in 'resources/js2/modules/keywords
  component: () => import('@/modules/keywords/pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'Get keywords ideas for marketplaces like Etsy, Amazon and eBay. Discover how keywords trend over the year and what country the buyers live in.',
      },
      {
        property: 'og:title',
        content: 'eRank — Keyword Tool',
      },
      {
        property: 'og:description',
        content: 'Get keywords ideas for marketplaces like Etsy, Amazon and eBay. Discover how keywords trend over the year and what country the buyers live in.',
      },
      {
        property: 'og:site_name',
        content: 'eRank',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        name: 'twitter:title',
        content: 'eRank — Keyword Tool',
      },
      {
        name: 'twitter:description',
        content: 'Get keywords ideas for marketplaces like Etsy, Amazon and eBay. Discover how keywords trend over the year and what country the buyers live in.',
      },
      {
        name: 'twitter:card',
        content: 'summary',
      },
      {
        name: 'p:domain_verify',
        content: '4a452b9edfa7318bd9a45fe0d20a25c0',
      },
      {
        name: 'google-site-verification',
        content: '-2cfMO7MeRJeifFFxsIOq3Ifssa2ai61ngBq40DYYkM',
      },
      {
        name: 'msvalidate.01',
        content: '65CFA6CFB407B1A92CCA3F3FB7B1D174',
      },
      {
        name: 'msapplication-TileColor',
        content: '#da532c',
      },
      {
        name: 'msapplication-config',
        content: assetUrl('/favicons/browserconfig.xml'),
      },
      {
        name: 'theme-color',
        content: '#ffffff',
      },
      {
        name: 'apple-mobile-web-app-capable',
        content: 'yes',
      },
      {
        name: 'mobile-web-app-capable',
        content: 'yes',
      },
      {
        page_slug: 'keyword-tool',
      },
    ],
    noScroll: true,
    requiresAuth: true,
    title: 'eRank — Keyword Tool',
  },
  children: [
    {
      component: () => import('@/modules/keywords/pages/KwRelated.vue'),
      name: 'Keyword Ideas',
      path: '',
    },
    {
      component: () => import('@/modules/keywords/pages/NearMatches.vue'),
      name: 'Near Matches',
      path: 'near-matches',
    },
    {
      component: () => import('@/modules/keywords/pages/SERPAnalysisPage.vue'),
      name: 'SERP Analysis',
      path: 'serp-analysis',
    },
    {
      component: () => import('@/modules/keywords/pages/TopListing.vue'),
      name: 'Top Listings',
      path: 'top-listings',
    },
    {
      component: () => import('@/modules/keywords/pages/Marketplaces.vue'),
      name: 'Marketplaces',
      path: 'marketplaces',
    },
  ],
};
